import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ComponentRef, OnDestroy, ViewChild, ViewContainerRef } from '@angular/core';
import { XMLElementBaseComponent } from '../base';
import { SubPoint } from '../volkswagen.types';

@Component({
  selector: 'app-xml-subpoint',
  imports: [CommonModule],
  standalone: true,
  template: `
    <span class="mb-2 mr-2 inline-block">{{ data.text }}</span>

    <ng-template #childrenContainer class="subpoint-children space-y-2"></ng-template>

    <!-- <div class="bg-slate-50 text-xs">{{ data | json }}</div> -->
  `,
})
export class SubPointComponent extends XMLElementBaseComponent<SubPoint> implements AfterViewInit, OnDestroy {
  @ViewChild('childrenContainer', { read: ViewContainerRef })
  childrenContainer!: ViewContainerRef;

  private childComponents: ComponentRef<XMLElementBaseComponent>[] = [];

  ngAfterViewInit() {
    if (this.data?.children) {
      this.childRenderService.setProvider(this.provider);
      this.childComponents = this.childRenderService.renderChildren(this.data.children, this.childrenContainer);
    }
  }

  ngOnDestroy() {
    this.childComponents.forEach((ref) => ref.destroy());
  }
}
